<template>
  <div class="home-box" @scroll.passive="handleScroll($event)" ref="home">
    <div class="app-container">
      <div class="swiper">
        <swiper :options="swiperOptionsBanner">
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/1.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/2.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/3.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/4.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/5.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/6.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/7.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="imgWrap">
              <img src="@/assets/image/8.jpg" alt="" class="img-bg" />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 产品 -->
      <div class="data-statistics scroll01">
        <div class="xpath-log">
          <h2
            class="animate__animated animate__fadeInUpBig"
          >
            业务&产品
          </h2>
          <p
            class="animate__animated animate__fadeInUpBig"
            v-show="scroll01Show"
          >
            Business & Products
          </p>
        </div>
        <div
          class="more animate__animated animate__fadeInUpBig"
          v-show="scroll01Show"
          @click="ProductMoreBtn"
        >
          <div class="btn-container">
            <button>
              <span class="text">更多产品</span>
              <div class="icon-container">
                <div class="icon icon--left">
                  <i class="el-icon-right"></i>
                </div>
                <div class="icon icon--right">
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="wrap scroll02" ref="scroll02">
        <div
          class="tile animate__animated animate__fadeInUpBig"
          v-show="scroll02Show"
          @click="productBtn(1)"
          @mouseenter="getprouctData(1)"
        >
          <img src="@/assets/image/11.jpg" />
          <div class="text">
            <h1>整车控制器</h1>
            <h2 class="animate-text">Vehicle Control Unit</h2>
            <p class="animate-text" v-for="(item,inx) in product1" :key="inx"
            v-if="inx < 4">
              {{ item }}
            </p>
            <!-- <p class="animate-text">智能网联整车控制器</p>
            <p class="animate-text">整车控制器</p>
            <p class="animate-text">分布式电子控制器</p> -->
            <div class="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div
          class="tile animate__animated animate__fadeInUpBig"
          v-show="scroll02Show"
          @click="productBtn(2)"
          @mouseenter="getprouctData(2)"
        >
          <img src="@/assets/image/9.jpg" />
          <div class="text">
            <h1>电驱动与传动系统</h1>
            <h2 class="animate-text">Electric Driving Transmission System</h2>
            <p class="animate-text" v-for="(item,inx) in product2" :key="inx"
            v-if="inx < 4">
              {{ item }}
            </p>
            <div class="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div
          class="tile animate__animated animate__fadeInUpBig"
          v-show="scroll02Show"
          @click="productBtn(3)"
          @mouseenter="getprouctData(3)"
        >
          <img src="@/assets/image/10.jpg" />
          <div class="text">
            <h1>高压集成控制器</h1>
            <h2 class="animate-text">High Voltage Lnegrated Controller</h2>
            <p class="animate-text" v-for="(item,inx) in product3" :key="inx"
            v-if="inx < 4">
              {{ item }}
            </p>
            <div class="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 公司动态 -->
      <div class="data-statistics scroll03" ref="scroll03">
        <div class="xpath-log" v-show="scroll03Show">
          <h2 class="animate__animated animate__fadeInUpBig">公司动态</h2>
          <p class="animate__animated animate__fadeInUpBig">
            News & Information
          </p>
        </div>
        <div
          class="more animate__animated animate__fadeInUpBig"
          v-show="scroll01Show"
          @click="NewsMoreBtn(1)"
        >
          <div class="btn-container">
            <button>
              <span class="text">更多动态</span>
              <div class="icon-container">
                <div class="icon icon--left">
                  <i class="el-icon-right"></i>
                </div>
                <div class="icon icon--right">
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="new_box scroll04" ref="scroll04">
        <div class="News">
          <router-link v-for="(item,index) in newsData1" :key="index"
          :to="'/NewDetail/'+ item.id" target="_blank">
            <dl v-show="scroll04Show">
              <dd>
                <img
                  :src="item.pic"
                  class="animate__animated animate__fadeInUpBig"
                />
              </dd>
              <dt>
                <h2
                  :title="item.newsTitle"
                  class="animate__animated animate__fadeInUpBig"
                >
                  {{ item.newsTitle }}
                </h2>
                <p
                  :title="item.description"
                  class="animate__animated animate__fadeInUpBig"
                >
                  {{ item.description }}
                </p>
              </dt>
            </dl>
          </router-link>
        </div>
      </div>
      <!-- 行业新闻 -->
      <div class="data-statistics_us" v-if="newsData2.length!=0">
        <div class="xpath-log">
          <h2 class="animate__animated animate__fadeInUpBig">行业新闻</h2>
          <p class="animate__animated animate__fadeInUpBig">Industry News</p>
        </div>
        <div
          class="more animate__animated animate__fadeInUpBig"
          @click="NewsMoreBtn(2)"
        >
          <div class="btn-container">
            <button>
              <span class="text">更多新闻</span>
              <div class="icon-container">
                <div class="icon icon--left">
                  <i class="el-icon-right"></i>
                </div>
                <div class="icon icon--right">
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="blog-slider" ref="scroll12" v-if="scroll12Show&&newsData2.length!=0">
        <div class="slider_box">
           <!-- @slideChange="slideChange()" -->
          <swiper :options="swiperOptionsNew" class="swiper_box">
            <swiper-slide class="blog-slider__item"
            v-for="(item,index) in newsData2" :key="index">
              <div class="blog-slider__img">
                <img :src="item.pic" :alt="item.newsTitle" />
              </div>
              <div class="blog-slider__content">
                <span class="blog-slider__code">{{ item.createDatetime }}</span>
                <div class="blog-slider__title">
                  {{ item.newsTitle }}
                </div>
                <div class="blog-slider__text">
                  {{ item.description }}
                </div>
                <router-link class="blog-slider__button" :to="'/NewDetail/'+ item.id" target="_blank">READ MORE</router-link>
              </div>
            </swiper-slide>
            <div class="blog-slider__pagination"></div>
          </swiper>
        </div>
      </div>
      <!-- 合作案例 -->
      <div class="data-statistics_us" v-if="newsData3.length!=0">
        <div class="xpath-log">
          <h2 class="animate__animated animate__fadeInUpBig">案例展示</h2>
          <p class="animate__animated animate__fadeInUpBig">
            Case presentation
          </p>
        </div>
      </div>
      <div ref="scroll11" class="TopstoryItem scroll11" v-if="newsData3.length!=0">
        <div class="TopstoryItem-isRecommend">
          <div class="FeedItem animate__animated animate__zoomInLeft">
            <dl @click="NewsMoreBtn(3)">
              <dt class="dtone">
                <img :src="newsData3[0].pic" :alt="newsData3[0].newsTitle">
              </dt>
              <dd>
                <div>
                  <strong>典型案例</strong>
                  <div class="line_div">
                    <div class="line-one"></div>
                  </div>
                  <div>
                    <p>{{ newsData3[0].newsTitle }}</p>
                  </div>
                </div>
                <button class="button type3">
                  进入更多了解
                </button>
              </dd>
            </dl>
            <dl @click="NewsMoreBtn(4)" v-if="newsData4.length!=0">
              <dt class="dttwo">
                <img :src="newsData4[0].pic" :alt="newsData4[0].newsTitle">
              </dt>
              <dd>
                <div>
                  <strong>科技项目</strong>
                  <div class="line_div">
                    <div class="line-one"></div>
                  </div>
                  <div>
                    <p>{{ newsData4[0].newsTitle }}</p>
                  </div>
                </div>
                <button class="button type3">
                  进入更多了解
                </button>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- 企业荣誉 -->
      <div class="data-statiback scroll05" ref="scroll05">
        <div class="xpath-log" v-show="scroll05Show">
          <h2
            style="color: #fbc638"
            class="animate__animated animate__fadeInUpBig"
          >
            企业荣誉
          </h2>
          <p
            style="color: #fbc638"
            class="animate__animated animate__fadeInUpBig"
          >
            Enterprise Honor
          </p>
        </div>
      </div>
      <div class="Honor_box scroll06" ref="scroll06">
        <div class="Enterprise_box" v-show="scroll06Show">
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>福田汽车</p>
              <p>优秀供应商技术领先奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>福田智蓝汽车</p>
              <p>生态价值奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>福田欧辉</p>
              <p>氢力相助奖、服务之星奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>“中国汽车工业科学技术奖”</p>
              <p>科技进步奖一等奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>北京国际道路运输车辆展</p>
              <p>创新产品大奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2021</h2></dd>
            <dt>
              <p>21世纪汽车『金引擎』案例</p>
              <p>技术创新汽车（配套）企业</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2018</h2></dd>
            <dt>
              <p>电动汽车核心零部件</p>
              <p>百强榜</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2017</h2></dd>
            <dt>
              <p>中国道路运输杯</p>
              <p>最佳新能源客车零部件奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2016</h2></dd>
            <dt>
              <p>中国公益节年度责任品牌奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2018</h2></dd>
            <dt>
              <p>北汽、福田欧辉客车</p>
              <p>年度“科技创新奖”</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2015</h2></dd>
            <dt>
              <p>北汽福田</p>
              <p>年度优秀供应商科技创新奖</p>
            </dt>
          </dl>
          <dl class="animate__animated animate__fadeInUpBig">
            <dd><h2>2014</h2></dd>
            <dt>
              <p>北京市科技进步奖</p>
              <p>一等奖</p>
            </dt>
          </dl>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="data-Partners scroll07" ref="scroll07">
        <div class="xpath-log" v-show="scroll07Show">
          <h2 class="animate__animated animate__fadeInUpBig">合作伙伴</h2>
          <p class="animate__animated animate__fadeInUpBig">
            Clients & Partners
          </p>
        </div>
        <div class="css-p7jonp"></div>
      </div>
      <div class="Partners_box scroll08">
        <div
          class="Clients animate__animated animate__fadeInUpBig"
        >
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he1.png" title="卡文汽车"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he2.png" title="三一重工"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he3.png" title="东风柳汽"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he4.png" title="申龙客车"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he5.png" title="杭叉"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he6.png" title="时代电动"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he7.png"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he8.png" style="max-width: 200%;" title="广泰"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he9.png" title="中集"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he10.png" title="金旅客车"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he11.png" style="max-width: 120%;max-height: 120%;" title="德创未来"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he12.png" title="远程"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he14.png" title="中国航天"/>
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/he13.png" style="max-width: 150%;" title="京环装备"/>
          </div>
          <!-- <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/17.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/18.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/19.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/20.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/21.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/22.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/23.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/24.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/25.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/26.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/27.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/28.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/29.jpg" />
          </div>
          <div class="img_box animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/30.jpg" />
          </div> -->
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="data-statistics_us scroll09">
        <div class="xpath-log">
          <h2 class="animate__animated animate__fadeInUpBig">联系我们</h2>
          <p class="animate__animated animate__fadeInUpBig">Contact Us</p>
        </div>
      </div>
      <div class="Contact_box scroll10">
        <div class="smc_Area">
          <div class="smc_title animate__animated animate__fadeInUpBig">
            <h1>联系我们</h1>
            <p>联系电话：{{ contactus.tel }}</p>
            <p>营销中心：{{ contactus.phone }}</p>
            <!-- <p>公司传真：010-68944475</p> -->
            <p>公司邮箱：{{ contactus.email }}</p>
            <p>公司地址：{{ contactus.addr }}</p>
          </div>
          <div class="smartImg animate__animated animate__fadeInUpBig">
            <img src="@/assets/image/55.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import News from '@/api/api.js'
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      product1: [],
      product2: [],
      product3: [],
      product4: [],
      newsData1: [],
      newsData2: [],
      newsData3: [],
      newsData4: [],
      contactus: '',
      swiperOptionsBanner: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        loop: true, //环路，让Swiper看起来是循环的
        speed: 500, //速度
        // autoplay: true, //自动切换
      },
      swiperOptionsNew: {
        pagination: {
          el: ".blog-slider__pagination", //与slot="pagination"处 class 一致
          // clickable: true, //轮播按钮支持点击
        },
        loop: true, //环路，让Swiper看起来是循环的
        loopFillGroupWithBlank: true,
        speed: 200, //速度
        // autoplay: true, //自动切换
        // spaceBetween: 30,
        effect: "fade",
        // mousewheel: {
        //   invert: false,
        // },
      },

      scroll01Show: true,
      scroll02Show: false,
      scroll03Show: false,
      scroll04Show: false,
      scroll05Show: false,
      scroll06Show: false,
      scroll07Show: false,
      // scroll08Show: false,
      // scroll09Show: false,
      // scroll10Show: false,
      scroll12Show: false,
    };
  },
  created() {
    // this.getprouctData(1)
    // this.getprouctData(2)
    // this.getprouctData(3)
    this.getData(1)
    this.getData(2)
    this.getData(3)
    this.getData(4)
    this.getContactInfo()
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll,true);
  },
  methods: {
    async getContactInfo(){
      // console.log('this.contact为空',this.contact == '')
      if(this.contactus == ''){
        let res = await News.getUser();
        // console.log(res)
        this.contactus = res.msg;
      }
      
    },
    async getprouctData(classId){
      // console.log('product'+classId+'是否为空', this['product'+classId].length == 0)
      if(this['product'+classId].length == 0){
        this.searchDTO={
          classId
        };
        let res =await News.getProductList(this.searchDTO);
        this['product'+classId] = Array.from(res.data,({productName})=>productName);
      }
      // console.log('product'+classId, this['product'+classId])
    },
    async getData(classId){
      this.searchDTO = {
        limit: 4,
        classId  //新闻分类
      };
      let res = await News.getNewList(this.searchDTO);
      this['newsData'+classId] = res.data;
      if(classId == 2) this.scroll12Show = true
      // console.log('newsData'+classId,this['newsData'+classId])
    },
    handleScroll(ev) {
      // console.log("监听ev时时滚动的距离", ev.target.scrollTop);
      let refArray = [
        { ref: "scroll02", show: "scroll02Show" },
        { ref: "scroll03", show: "scroll03Show" },
        { ref: "scroll04", show: "scroll04Show" },
        { ref: "scroll05", show: "scroll05Show" },
        { ref: "scroll06", show: "scroll06Show" },
        { ref: "scroll07", show: "scroll07Show" },
        // { ref: "scroll08", show: "scroll08Show" },
        // { ref: "scroll09", show: "scroll09Show" }, //
        // { ref: "scroll10", show: "scroll10Show" },
        { ref: "scroll11", show: "scroll11Show" },
        { ref: "scroll12", show: "scroll12Show" },
      ];
      refArray.forEach((r, i) => {
        let dom = this.$refs[r.ref]; // 等同于document.querySelector('.earth') true
        if (dom) {
          var a, b, c, d;
          d = dom.offsetTop; // 元素距离相对父级的高度，这里父级指的是body
          a = eval(d + 200);
          b = ev.target.scrollTop; //  获取窗口滚动条高度
          c = ev.target.clientHeight; // 获取浏览器可视区的高度
          if (b + c >= a) {
            this[r.show] = true;
            // if(r.ref=='scroll09')this.getContactInfo()
          }
        }
      });
    },
    // 产品中心的更多
    ProductMoreBtn() {
      this.$router.push('/ProductCategoryAll');
    },
    // 产品中心的列表
    productBtn(model) {
      this.$router.push('/ProductList/'+ model);
    },
    // 新闻资讯的更多
    NewsMoreBtn(model) {
      this.$router.push('/NewPageList/'+ model);
    },
  },
  beforeDestroy() {
    console.log('移除监听滚动')
    window.removeEventListener("scroll", this.handleScroll,true);
  }
};
</script>

<style lang="scss"  scoped >
.fixed-nav {
  position: fixed;
  top: 200;
  z-index: 999;
}
.home-box {
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px #26a3de;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    background: #26a3de;
  }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px #26a3de;
    -webkit-box-shadow: inset 0 0 5px rgba(44, 65, 180, 0.5);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
.more {
  margin-top: 10px;
  .btn-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--bg);
  }
  .btn-container {
    --btn-bg: #0065b3;
  }

  button {
    --width: 120px;
    --height: 30px;
    border: 0;
    position: relative;
    min-width: var(--width);
    min-height: var(--height);
    border-radius: var(--height);
    color: #fff;
    font-family: "Montserrat";
    font-weight: bold;
    background: linear-gradient(rgb(255, 255, 255), #26a3de);
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 1rem;
  }
  button .text,
  button .icon-container {
    position: relative;
    z-index: 2;
    margin-right: 15px;
  }
  button .icon-container {
    font-size: 25px;
    position: relative;
    height: 30px;
    line-height: 30px;
    transition: transform 500ms ease;
  }
  button .icon-container .icon {
    position: absolute;
    left: 0;
    top: 0;
    width: var(--icon-size);
    height: var(--icon-size);
    transition: transform 500ms ease, opacity 250ms ease;
  }
  button .icon-container .icon--left {
    transform: translateX(-200%);
    opacity: 0;
  }
  button::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--btn-bg);
    border-radius: var(--height);
    z-index: 1;
    transition: transform 500ms ease;
  }
  button:hover::after {
    transform: translateX(65%);
  }
  button:hover .icon-container {
    transform: translateX(10%);
  }
  button:hover .icon-container .icon--left {
    transform: translateX(0);
    opacity: 1;
  }
  button:hover .icon-container .icon--right {
    transform: translateX(20%);
    opacity: 0;
  }
  button:hover .text {
    color: #000 !important;
  }
}
.app-container {
  overflow: hidden;
  background-image: url("../../assets/image/bg.jpg");
  .swiper {
    width: 100%;
    height: 100vh;
    // position: relative;
    @media only screen and (min-width: 300px) and (max-width: 768px) {
      width: 100%;
      height: 400px;
    }
    & >>> .swiper-container {
      width: 100%;
      height: 100vh;
      transition-delay: 0.3s;
      @media only screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
        height: 400px;
      }
      .swiper-slide {
        width: 100%;
        height: 100vh;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          width: 100%;
          height: 400px;
        }
        .imgWrap {
          width: 100%;
          height: 100%;
          // position: relative;
          .img-bg {
            width: 100%;
            height: 100%;
          }
        }
        .heightBg {
          box-sizing: border-box;
          padding: 15px;
          width: 100%;
          position: absolute;
          bottom: 10%;
          right: -40%;
          cursor: pointer;
          display: flex;
          justify-content: center;
          height: 100px;

          .cta {
            // width: 200px;
            display: flex;
            padding: 10px 35px 5px 20px;
            text-decoration: none;
            font-family: "Poppins", sans-serif;
            font-size: 30px;
            color: white;
            background: #26a3de;
            transition: 1s;
            box-shadow: 6px 6px 0 #fff;
            -webkit-transform: skewX(-15deg);
            transform: skewX(-15deg);
            @media only screen and (min-width: 300px) and (max-width: 768px) {
              display: none;
            }
          }

          .cta:focus {
            outline: none;
          }

          .cta:hover {
            transition: 0.5s;
            box-shadow: 10px 10px 0 #fbc638;
          }

          .cta span:nth-child(2) {
            transition: 0.5s;
            margin-right: 0px;
          }

          .cta:hover span:nth-child(2) {
            transition: 0.5s;
            margin-right: 45px;
          }

          span {
            -webkit-transform: skewX(15deg);
            transform: skewX(15deg);
            line-height: 55px;
          }

          span:nth-child(2) {
            width: 6px;
            margin-left: 10px;
            // position: relative;
            top: 12%;
          }

          /**************SVG****************/

          path.one {
            transition: 0.4s;
            -webkit-transform: translateX(-60%);
            transform: translateX(-60%);
          }

          path.two {
            transition: 0.5s;
            -webkit-transform: translateX(-30%);
            transform: translateX(-30%);
          }

          .cta:hover path.three {
            -webkit-animation: color_anim 1s infinite 0.2s;
            animation: color_anim 1s infinite 0.2s;
          }

          .cta:hover path.one {
            -webkit-transform: translateX(0%);
            transform: translateX(0%);
            -webkit-animation: color_anim 1s infinite 0.6s;
            animation: color_anim 1s infinite 0.6s;
          }

          .cta:hover path.two {
            -webkit-transform: translateX(0%);
            transform: translateX(0%);
            -webkit-animation: color_anim 1s infinite 0.4s;
            animation: color_anim 1s infinite 0.4s;
          }
          @-webkit-keyframes color_anim {
            0% {
              fill: white;
            }
            50% {
              fill: #fbc638;
            }
            100% {
              fill: white;
            }
          }

          @keyframes color_anim {
            0% {
              fill: white;
            }
            50% {
              fill: #fbc638;
            }
            100% {
              fill: white;
            }
          }
        }
      }
      .swiper-slide-active {
        .bounceInDown {
          animation: bounceInDown;
          animation-duration: 2s;
        }
        .bounceInDown {
          animation: bounceInDown;
          animation-duration: 2s;
        }
        .bounceInLeft {
          animation: bounceInLeft;
          animation-duration: 2s;
        }
      }
      .swiper-pagination {
        .swiper-pagination-bullet {
          // position: relative;
          margin: 20px 10px;
          width: 50px;
          height: 4px;
          overflow: hidden;
          border-radius: 2px;
          background: #26a3de;
          background-clip: content-box;
          z-index: 168;
          top: -3px;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            position: relative;
            margin: 2px 1px;
            width: 5px;
            height: 4px;
            overflow: hidden;
            border-radius: 2px;
            background: #26a3de;
            background-clip: content-box;
            z-index: 168;
            top: -3px;
          }
        }
      }
      .swiper-pagination-bullets {
        bottom: 10px;
        text-align: right;
        padding-right: 50px;
        width: calc(100% - 50px);
        // @media only screen and (min-width: 300px) and (max-width: 768px) {
        //   margin-left: 0;
        // width: 0;
        // }
      }
    }
  }
  .data-statistics {
    background: #fff;
    height: 100%;
    width: 100%;
    margin: 30px auto;
    // position: relative;
    overflow: hidden;
    padding: 100px 0 60px;
    margin: 0 auto !important;
    z-index: 1;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      margin: 30px auto;
    }
    .xpath-log {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        color: rgb(102, 113, 128);
        font-size: 18px;
      }
      h2 {
        color: rgb(102, 113, 128);
        font-size: 72px;
        @media screen and (min-width: 300px) and (max-width: 768px) {
          font-size: 32px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .data-statistics_us {
    // background: #fff;
    height: 100%;
    width: 100%;
    margin: 30px auto;
    // position: relative;
    overflow: hidden;
    padding: 100px 0 60px;
    margin: 0 auto !important;
    z-index: 1;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      margin: 30px auto;
    }
    .xpath-log {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        // color: rgb(102, 113, 128);
        color: #fff;
        font-size: 18px;
      }
      h2 {
        // color: rgb(102, 113, 128);
        color: #fff;
        font-size: 72px;
        @media screen and (min-width: 300px) and (max-width: 768px) {
          font-size: 32px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .data-statiback {
    background: linear-gradient(rgba(23, 24, 26, 0.5), rgb(23, 24, 26)),
      url("../../assets/image/34.jpg") center center / cover no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    margin: 0 auto !important;
    // position: relative;
    overflow: hidden;
    padding: 100px 0 60px;
    z-index: 1;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      padding: 50px 0;
    }
    .xpath-log {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        color: rgb(102, 113, 128);
        font-size: 18px;
      }
      h2 {
        color: rgb(102, 113, 128);
        font-size: 72px;
        @media screen and (min-width: 300px) and (max-width: 768px) {
          font-size: 32px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .data-Partners {
    background: url("../../assets/image/16.jpg") no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
    margin: 0 auto !important;
    // position: relative;
    overflow: hidden;
    padding: 100px 0px 60px;
    z-index: 1;
    // opacity: 0.5;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      margin: 30px auto;
    }
    .xpath-log {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        color: #fff;
        font-size: 18px;
      }
      h2 {
        color: #fff;
        font-size: 72px;
        @media screen and (min-width: 300px) and (max-width: 768px) {
          font-size: 32px;
          margin-bottom: 20px;
        }
      }
    }
    .css-p7jonp {
      background-color: rgba(0, 32, 77, 0.6);
      position: absolute;
      height: 340px;
      width: 100%;
      top: 0;
      z-index: -1;
    }
  }
  .wrap {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      display: flex;
      flex-direction: column;
    }
    .tile {
      width: calc((100% - 0px) / 3);
      height: 600px;
      background-color: #26a3de;
      display: inline-block;
      background-size: cover;
      // position: relative;
      cursor: pointer;
      transition: all 0.4s ease-out;
      // box-shadow: 0px 35px 77px -17px rgba(0, 0, 0, 0.44);
      overflow: hidden;
      color: white;
      font-family: "Roboto";
      @media screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
      }
    }

    .tile img {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      transition: all 0.4s ease-out;
    }

    .tile .text {
      z-index: 99;
      position: absolute;
      padding: 30px;
      height: calc(100% - 60px);
      width: calc(100% - 60px);
    }

    .tile h1 {
      font-weight: 300;
      margin: 0;
      text-shadow: 2px 2px 10px #0065b3;
    }

    .tile h2 {
      font-weight: 100;
      margin: 20px 0 0 0;
      font-style: italic;
      transform: translateX(200px);
    }

    .tile p {
      font-weight: 300;
      margin: 30px 0;
      line-height: 25px;
      /*   opacity:0; */
      transform: translateX(-200px);
      transition-delay: 0.2s;
    }

    .animate-text {
      opacity: 0;
      transition: all 0.6s ease-in-out;
    }

    .tile:hover {
      /*   background-color:#26a3de; */
      // box-shadow: 0px 35px 77px -17px rgba(0, 0, 0, 0.64);
      transform: scale(1);
    }

    .tile:hover img {
      opacity: 0.2;
    }

    .tile:hover .animate-text {
      width: 100%;
      transform: translateX(0);
      opacity: 1;
    }

    .dots {
      position: absolute;
      bottom: 20px;
      right: 30px;
      margin: 0 auto;
      width: 30px;
      height: 30px;
      color: currentColor;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }

    .dots span {
      width: 5px;
      height: 5px;
      background-color: currentColor;
      border-radius: 50%;
      display: block;
      opacity: 0;
      transition: transform 0.4s ease-out, opacity 0.5s ease;
      transform: translateY(30px);
    }

    .tile:hover span {
      opacity: 1;
      transform: translateY(0px);
    }

    .dots span:nth-child(1) {
      transition-delay: 0.05s;
    }

    .dots span:nth-child(2) {
      transition-delay: 0.1s;
    }

    .dots span:nth-child(3) {
      transition-delay: 0.15s;
    }
  }
  .new_box {
    width: 100%;
    background: #fff;
    .News {
      width: var(--base-width);
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      background: #fff;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      a {
        display: block;
        width: calc((100% - 70px) / 2);
        height: 200px;
        margin: 0 70px 50px 0;
        &:nth-child(2n) {
          margin-right: 0;
        }
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          height: max-content;
          padding: 20px 10px;
          width: calc(100% - 20px);
          margin: 0;
        }
        dl {
          display: flex;
          justify-self: space-between;
          @media screen and (min-width: 300px) and (max-width: 768px) {
            width: 100%;
            height: 120px;
            margin-bottom: 20px;
            padding: 0 10px;
            box-sizing: content-box;
          }

          dd {
            width: 200px;
            height: 200px;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            @media screen and (min-width: 300px) and (max-width: 768px) {
              width: 120px;
              height: 120px;
              overflow: hidden;
            }
            img {
              height: 200px;
              transition: all 0.6s;
              @media screen and (min-width: 300px) and (max-width: 768px) {
                height: 120px;
                transition: all 0.6s;
              }
            }
            &:hover img {
              transform: scale(1.2);
              cursor: pointer;
            }
          }
          dt {
            flex: 1;
            padding-left: 30px;
            display: flex;
            flex-direction: column;

            @media screen and (min-width: 300px) and (max-width: 768px) {
              padding: 0 10px;
            }
            h2 {
              font-size: 20px;
              line-height: 30px;
              height: 90px;
              font-weight: bold;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              display: -webkit-box;
              -webkit-box-orient: vertical;

              @media screen and (min-width: 300px) and (max-width: 768px) {
                font-size: 18px;
                line-height: 30px;
                height: 30px;
                font-weight: bold;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
              }
              &:hover {
                color: #1a46a7;
              }
            }
            p {
              margin-top: 10px;
              line-height: 26px;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-box-line-clamp: 3;
              -webkit-box-orient: vertical;
              height: 78px;
              &:hover {
                color: #26a3de;
              }
            }
          }
        }
      }
    }
  }

  .Honor_box {
    width: 100%;
    background: rgb(23, 24, 26);
    .Enterprise_box {
      width: var(--base-width);
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }

      dl {
        width: calc((100% - 120px) / 3);
        height: 120px;
        margin-bottom: 100px;
        background: url("../../assets/image/bgGlory@2x.971ed2a1.png") no-repeat;
        background-size: 100% 100%;
        color: #fbc638;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @media screen and (min-width: 300px) and (max-width: 768px) {
          width: calc((100% - 60px) / 2);
          height: 60px;
          margin-bottom: 40px;
          padding: 0 10px;
          box-sizing: content-box;
        }

        dd h2 {
          font-size: 36px;
          text-align: center;

          @media screen and (min-width: 300px) and (max-width: 768px) {
            font-size: 14px;
          }
        }
        dt p {
          font-size: 20px;
          text-align: center;
          line-height: 2;

          @media screen and (min-width: 300px) and (max-width: 768px) {
            font-size: 8px;
          }
        }
      }
    }
  }
  .Partners_box {
    background: rgb(107, 125, 153);
    width: 100%;
    padding: 100px 0;

    @media screen and (min-width: 300px) and (max-width: 768px) {
      padding: 30px 0;
    }
    .Clients {
      width: var(--base-width);
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }

      .img_box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc((100% - 640px) / 4);
        padding: 0 80px;
        height: 100px;
        margin-bottom: 50px;

        @media screen and (min-width: 300px) and (max-width: 768px) {
          width: calc((100% - 60px) / 2);
          height: 60px;
          margin-bottom: 40px;
          padding: 0 10px;
          box-sizing: content-box;
        }
        img {
          max-width: 100%;
          max-height: 100%;
          transition: .6s;
        }
        img:hover {
          transform: scale(1.2);
        }
      }
    }
  }
  .Contact_box {
    width: 100%;
    padding-bottom: 100px;
    @media screen and (min-width: 300px) and (max-width: 768px) {
      width: 100%;
    }
    ul {
      width: var(--base-width);
      margin: 0 auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        width: 100%;
      }
      li {
        width: calc((100% - 60px) / 3);
        display: flex;
        justify-self: space-between;
        flex-direction: column;

        position: relative;
        z-index: 1;
        padding: 30px 0;
        // @media only screen and (min-width: 300px) {
        //   width: 100%;
        // margin-bottom: 20px;
        // }
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          width: 100%;
          margin-bottom: 20px;
        }
        .bg_box {
          background-color: rgba(0, 13, 26, 0.8);
          z-index: -1;
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
        }
        h2 {
          padding: 0 30px;
          font-size: 32px;
          color: #fff;
          text-align: center;
          margin: 10px 0;
        }
        p {
          font-size: 14px;
          color: #fff;
          text-align: center;
        }
        .line_box {
          // width: 100%;
          height: 1px;
          background: #fff;
          margin: 20px 30px 30px;
        }
        dl {
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          padding: 0 30px;
          dt img {
            width: 32px;
            height: 32px;
          }
          dd p {
            margin-left: 20px;
            font-size: 16px;
            text-align: left;
          }
        }
      }
      li:nth-child(1) {
        background: url("../../assets/image/31.jpg") no-repeat;
        background-size: 100% 100%;
      }
      li:nth-child(2) {
        background: url("../../assets/image/32.jpg") no-repeat;
        background-size: 100% 100%;
      }
      li:nth-child(3) {
        background: url("../../assets/image/33.jpg") no-repeat;
        background-size: 100% 100%;
      }
    }
    .smc_Area {
      width: var(--base-width);
      margin: 0 auto;
      height: 400px;
      display: flex;
      justify-content: space-between;
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      line-height: 30px;
      // color: #000;
      @media only screen and (min-width: 300px) and (max-width: 768px) {
        width: calc(100% - 20px);
        padding: 0 10px;
        height: max-content;
        background: transparent;
      }
      .smc_title {
        width: 49%;
        h1 {
          font-weight: 700;
          color: #1a46a7;
          border-bottom: 1px solid #eee;
          padding-bottom: 30px;
        }
        p {
          font-size: 18px;
          line-height: 50px;
        }
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          width: 100%;
          padding: 20px 10px;
          background: #fff;
          border-radius: 10px;
        }
      }
      .smartImg {
        width: 50%;
        img {
          width: 100%;
          height: 100%;
        }
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          display: none;
        }
      }
    }
  }
  // 合作案例
  .TopstoryItem {
    width: 100%;
    padding-bottom: 60px;
    .TopstoryItem-isRecommend {
      width: var(--base-width);
      margin: 0 auto;
      text-align: center;
      @media only screen and (min-width: 300px) and (max-width: 768px) {
        width: calc(100% - 20px);
        padding: 0 10px;
      }
      .FeedItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media only screen and (min-width: 300px) and (max-width: 768px) {
          flex-wrap: wrap;
        }
        dl {
          width: 49%;
          height: 500px;
          background: #fff;
          display: flex;
          border-radius: 4px;
          overflow: hidden;
          @media only screen and (min-width: 300px) and (max-width: 768px) {
            width: 100%;
            height: max-content;
            flex-wrap: wrap;
            padding: 20px 10px;
          }
          dt {
            // background-repeat: no-repeat;
            // background-position: 50% 50%;
            // background-size: cover;
            width: 50%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            @media only screen and (min-width: 300px) and (max-width: 768px) {
              width: 100%;
            }
            img {
              max-width: 100%;
            }
          }

          // .dtone {
          //   background-image: url("../../assets/image/45.jpg");
          // }
          // .dttwo {
          //   background-image: url("../../assets/image/46.jpg");
          // }
          dd {
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            @media only screen and (min-width: 300px) and (max-width: 768px) {
              width: 100%;
            }
            p {
              padding: 0 10px;
              text-align: left;
            }
            .line_div {
              margin: 20px 0;
              width: 100%;
              height: 1px;
              border-bottom-width: 1px;
              border-bottom-style: solid;
              border-bottom-color: rgba(221, 221, 221, 1);
              .line-one {
                width: 30px;
                height: 1px;
                border-bottom-width: 2px;
                border-bottom-style: solid;
                border-bottom-color: #50b6bb;
                margin-left: 50%;
                transform: translateX(-15px);
              }
            }
            .type3 {
              color: #435a6b;
            }
            .button {
              position: relative;
              padding: 10px;
              border: none;
              background-color: transparent;
              cursor: pointer;
              outline: none;
              font-size: 18px;
              margin-top: 20px;
            }
            .type3::after,
            .type3::before {
              content: "";
              display: block;
              position: absolute;
              width: 20px;
              height: 10px;
              border: 2px solid;
              transition: all 0.6s ease;
              border-radius: 2px;
            }
            .type3::after {
              bottom: 0;
              right: 0;
              border-top-color: transparent;
              border-left-color: transparent;
              border-bottom-color: #435a6b;
              border-right-color: #435a6b;
            }
            .type3::before {
              top: 0;
              left: 0;
              border-bottom-color: transparent;
              border-right-color: transparent;
              border-top-color: #435a6b;
              border-left-color: #435a6b;
            }
            .type3:hover:after,
            .type3:hover:before {
              border-bottom-color: #435a6b;
              border-right-color: #435a6b;
              border-top-color: #435a6b;
              border-left-color: #435a6b;
              width: 150px;
              height: 50px;
            }
          }
        }
      }
    }
  }
}

.blog-slider {
  width: var(--base-width);
  margin: 0 auto;
  @media only screen and (min-width: 300px) and (max-width: 768px) {
    width: calc(100% - 20px);
    padding: 0 10px;
  }
  .slider_box {
    width: var(--base-width);
    margin: 0 auto;
    border-radius: 10px;
    position: relative;
    background: #fff;
    height: 400px;
    @media only screen and (min-width: 300px) and (max-width: 768px) {
      width: calc(100% - 20px);
      padding: 0 10px;
      height: max-content;
    }
  }
  .swiper_box {
    width: 110%;
    position: absolute;
    top: 10%;
    left: -10%;
    bottom: 10%;
    @media only screen and (min-width: 300px) and (max-width: 768px) {
      width: 100%;
      position: static;
    }
  }
}

.blog-slider__item {
  display: flex;
  align-items: center;
}

.blog-slider__item .blog-slider__img img {
  opacity: 1;
  transition-delay: 0.3s;
}
.blog-slider__content {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 10% 50px;
  .blog-slider__title {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .blog-slider__text {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
}
.blog-slider__item .blog-slider__content > * {
  opacity: 1;
  transform: none;
}
.blog-slider__item .blog-slider__content > *:nth-child(1) {
  transition-delay: 0.3s;
}
.blog-slider__item .blog-slider__content > *:nth-child(2) {
  transition-delay: 0.4s;
}
.blog-slider__item .blog-slider__content > *:nth-child(3) {
  transition-delay: 0.5s;
}
.blog-slider__item .blog-slider__content > *:nth-child(4) {
  transition-delay: 0.6s;
}
.blog-slider__item .blog-slider__content > *:nth-child(5) {
  transition-delay: 0.7s;
}
.blog-slider__item .blog-slider__content > *:nth-child(6) {
  transition-delay: 0.8s;
}
.blog-slider__item .blog-slider__content > *:nth-child(7) {
  transition-delay: 0.9s;
}
.blog-slider__item .blog-slider__content > *:nth-child(8) {
  transition-delay: 1s;
}
.blog-slider__item .blog-slider__content > *:nth-child(9) {
  transition-delay: 1.1s;
}
.blog-slider__item .blog-slider__content > *:nth-child(10) {
  transition-delay: 1.2s;
}
.blog-slider__item .blog-slider__content > *:nth-child(11) {
  transition-delay: 1.3s;
}
.blog-slider__item .blog-slider__content > *:nth-child(12) {
  transition-delay: 1.4s;
}
.blog-slider__item .blog-slider__content > *:nth-child(13) {
  transition-delay: 1.5s;
}
.blog-slider__item .blog-slider__content > *:nth-child(14) {
  transition-delay: 1.6s;
}
.blog-slider__item .blog-slider__content > *:nth-child(15) {
  transition-delay: 1.7s;
}
.blog-slider__img {
  width: 300px;
  flex-shrink: 0;
  height: 300px;
  background-image: linear-gradient(147deg, rgb(255, 255, 255), #26a3de 74%);
  // box-shadow: 50px 100px 50px 20px rgba(38,163,222,0.2);
  border-radius: 4px;
  transform: translateX(-80px);
  margin-left: 100px;
  @media only screen and (min-width: 300px) and (max-width: 768px) {
    display: none;
  }
}
.blog-slider__img:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(147deg, rgb(255, 255, 255), #26a3de 74%);
  border-radius: 4px;
  opacity: 0.6;
}
.blog-slider__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  border-radius: 4px;
  transition: all 0.3s;
}
.blog-slider__content > * {
  opacity: 0;
  transform: translateY(25px);
  transition: all 0.4s;
}
.blog-slider__code {
  color: #7b7992;
  margin-bottom: 15px;
  display: block;
  font-weight: 500;
}
.blog-slider__title {
  font-size: 24px;
  font-weight: 700;
  // color: #0d0925;
  margin-bottom: 20px;
}
.blog-slider__text {
  color: #4e4a67;
  margin-bottom: 30px;
  line-height: 1.5em;
}
.blog-slider__button {
  display: inline-flex;
  background-image: linear-gradient(147deg, rgb(255, 255, 255), #26a3de 74%);
  padding: 15px 35px;
  border-radius: 50px;
  color: #fff;
  box-shadow: 0px 14px 80px rgba(153, 174, 255, 0.4);
  text-decoration: none;
  font-weight: 500;
  justify-content: center;
  text-align: center;
  letter-spacing: 1px;
}

// .blog-slider .swiper-container-horizontal > .swiper-pagination-bullets,
// .blog-slider .swiper-pagination-custom,
// .blog-slider .swiper-pagination-fraction {
//   bottom: 10px;
//   left: 0;
//   width: 100%;
// }

.navBarWrap {
  position: fixed;
  top: 0;
  z-index: 999;
}
.animate {
  opacity: 0;
}
.fadeInUpBig {
  animation: fadeInUpBig 1s;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}
</style>
<style lang="scss">
.blog-slider__pagination {
  position: absolute;
  z-index: 21;
  right: 20px;
  width: 11px !important;
  text-align: center;
  left: auto !important;
  top: 50%;
  bottom: auto !important;
  transform: translateY(-50%);
  .swiper-pagination-bullet {
    width: 11px;
    height: 11px;
    display: block;
    border-radius: 10px;
    background: #062744;
    opacity: 0.2;
    transition: all 0.3s;
  }
  .swiper-pagination-bullet-active {
    opacity: 1 !important;
    background: #26a3de !important;
    height: 30px !important;
    box-shadow: 0px 0px 20px rgba(153, 174, 255, 0.3) !important;
  }

  .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 8px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/webapp/Home.vue